
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component
export default class DlgGuestDelete extends Vue {
  @Prop({ default: null }) guest!: any;
  @Prop({ default: false }) dialog!: boolean;

  loading: boolean = false;

  @Action('admin/guests/remove') removeGuest!: any;
  @Action('admin/guests/read') readAll!: any;

  private async remove() {
    this.loading = true;
    const res = await this.removeGuest(this.guest);
    this.loading = false;
    if (res) {
      await this.readAll();
      this.closeDialog();
    }
  }

  private closeDialog() {
    this.$emit('close');
  }
}
